var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenantOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 60,
    viewBox: "0 0 28 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.511154 36.5627L0.511249 36.5619L1.46553 28.8097C1.46555 28.8095 1.46557 28.8094 1.46559 28.8092C2.03045 24.2877 5.87487 20.8979 10.3925 20.8979H17.0723H17.0725C21.5911 20.8979 25.4349 24.2879 26.0003 28.8097L26.0003 28.8098L26.0012 28.8163L27.0741 36.5658C27.1558 37.2357 26.6408 37.9666 25.9154 38.1579C25.2173 38.2744 24.5087 38.3924 23.7999 38.5104C23.0771 38.6308 22.3542 38.7512 21.6423 38.8699L21.249 38.9356L21.2255 39.3336L20.1525 57.459C20.0527 58.6235 19.0826 59.5001 17.9079 59.5001H9.67696C8.50234 59.5001 7.53201 58.6227 7.43237 57.4589L6.35936 39.3336L6.3358 38.9356L5.94252 38.8699C5.43493 38.7852 4.94242 38.717 4.45783 38.6498C3.52186 38.5201 2.61549 38.3945 1.68723 38.1625L1.68727 38.1623L1.6741 38.1594C0.859548 37.9789 0.423088 37.2691 0.511154 36.5627Z",
    stroke: "#212121",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1779 8.94641C22.1779 13.6111 18.397 17.3928 13.7316 17.3928C9.06694 17.3928 5.28516 13.611 5.28516 8.94641C5.28516 4.28097 9.06691 0.5 13.7316 0.5C18.397 0.5 22.1779 4.28094 22.1779 8.94641Z",
    stroke: "#212121",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantOff);
export default __webpack_public_path__ + "static/media/tenant_off.ae18e516b2fa4bad75853ae170d81348.svg";
export { ForwardRef as ReactComponent };